module.exports = __webpack_public_path__ + "img/close-black-24dp.01ecdf8e.svg";